import React from "react";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// helpers
import displayName from "../helpers/displayName";
import displayDuration from "../helpers/displayDuration";

const useStyles = makeStyles(() => ({
  table: { minWidth: 650 },
  noResults: { fontStyle: "italic", color: "#b99d9d" },
}));

function RidersTable(props) {
  const classes = useStyles();

  if (!props.data) {
    return null;
  }

  const displayTotal = (total) => {
    let displayedTotal = total;
    if (props.isDuration) {
      displayedTotal = displayDuration(total);
    }
    if (props.hasDecimal) {
      displayedTotal = total.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return displayedTotal.toLocaleString();
  };

  let total = 0;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Date</TableCell>
            <TableCell align="left">Rider Name</TableCell>
            <TableCell align="left">Email</TableCell>
            <TableCell align="left">Mobile #</TableCell>
            <TableCell align="left">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(props.data)?.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={5}>
                <span className={classes.noResults}>No results found</span>
              </TableCell>
            </TableRow>
          )}
          {Object.keys(props.data).map((date) => {
            return props.data[date].map((rider) => {
              total += rider.total;

              return (
                <TableRow key={rider.rider.id} style={{ verticalAlign: "top" }}>
                  <TableCell align="left">{date}</TableCell>
                  <TableCell align="left">
                    {displayName(rider.rider?.firstName, rider.rider?.lastName)}
                  </TableCell>
                  <TableCell align="left">{rider.rider?.email}</TableCell>
                  <TableCell align="left">
                    {rider.rider?.mobileNumber}
                  </TableCell>
                  <TableCell align="left">
                    {displayTotal(rider.total)}
                  </TableCell>
                </TableRow>
              );
            });
          })}
          <TableRow>
            <TableCell colSpan={4} style={{ fontWeight: "bold" }}>
              TOTAL
            </TableCell>
            <TableCell align="left" style={{ fontWeight: "bold" }}>
              {displayTotal(total)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RidersTable;
